export default __webpack_public_path__ + "static/media/guide-7.4da93840.png";